import React, { useState } from 'react';
import { useUserAuth } from '../../context/UserAuthContext';
import { updateProfile, changePassword } from '../../api/userAuth.api';
import '../../styles/user-dashboard.css';

const Profile = () => {
  const { user, login, token } = useUserAuth();
  const [form, setForm] = useState({ name: user?.name || '', phone: user?.phone || '' });
  const [passForm, setPassForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);
  const [changingPass, setChangingPass] = useState(false);
  const [profileMsg, setProfileMsg] = useState('');
  const [passMsg, setPassMsg] = useState('');
  const [passError, setPassError] = useState('');
  const [profileError, setProfileError] = useState('');

  const initials = (user?.name || 'U').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

  const handleProfileSave = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setProfileError('Name is required.'); return; }
    setProfileError('');
    setSaving(true);
    try {
      const updated = await updateProfile(form);
      login(token, { ...user, ...updated });
      setProfileMsg('Profile updated successfully.');
      setTimeout(() => setProfileMsg(''), 3000);
    } catch (err) {
      setProfileError(err.response?.data?.message || 'Update failed.');
    } finally {
      setSaving(false);
    }
  };

  const handlePassChange = async (e) => {
    e.preventDefault();
    if (passForm.newPassword.length < 6) { setPassError('New password must be at least 6 characters.'); return; }
    if (passForm.newPassword !== passForm.confirmPassword) { setPassError('Passwords do not match.'); return; }
    setPassError('');
    setChangingPass(true);
    try {
      await changePassword({ currentPassword: passForm.currentPassword, newPassword: passForm.newPassword });
      setPassMsg('Password changed successfully.');
      setPassForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => setPassMsg(''), 3000);
    } catch (err) {
      setPassError(err.response?.data?.message || 'Failed to change password.');
    } finally {
      setChangingPass(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-container">
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#0f172a', marginBottom: '1.5rem' }}>My Profile</h1>

        {/* Avatar card */}
        <div className="profile-card" style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
          <div className="profile-avatar">{initials}</div>
          <div>
            <div className="profile-name">{user?.name}</div>
            <div className="profile-email">{user?.email}</div>
            {user?.phone && <div className="profile-email" style={{ marginTop: '0.15rem' }}>{user.phone}</div>}
          </div>
        </div>

        {/* Edit profile */}
        <div className="profile-card">
          <div className="profile-section-title">Edit Profile</div>
          {profileMsg && <div className="auth-success-box" style={{ marginBottom: '1rem' }}>{profileMsg}</div>}
          {profileError && <div className="auth-error-box" style={{ marginBottom: '1rem' }}>{profileError}</div>}
          <form className="profile-form" onSubmit={handleProfileSave}>
            <div className="profile-field">
              <label className="profile-label">Full Name</label>
              <input className="profile-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="profile-field">
              <label className="profile-label">Email</label>
              <input className="profile-input" value={user?.email || ''} disabled />
            </div>
            <div className="profile-field">
              <label className="profile-label">Phone Number</label>
              <input className="profile-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 98765 43210" />
            </div>
            <button type="submit" className="profile-save-btn" disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </form>
        </div>

        {/* Change password */}
        <div className="profile-card">
          <div className="profile-section-title">Change Password</div>
          {passMsg && <div className="auth-success-box" style={{ marginBottom: '1rem' }}>{passMsg}</div>}
          {passError && <div className="auth-error-box" style={{ marginBottom: '1rem' }}>{passError}</div>}
          <form className="profile-form" onSubmit={handlePassChange}>
            <div className="profile-field">
              <label className="profile-label">Current Password</label>
              <input type="password" className="profile-input" value={passForm.currentPassword} onChange={(e) => setPassForm({ ...passForm, currentPassword: e.target.value })} required />
            </div>
            <div className="profile-field">
              <label className="profile-label">New Password</label>
              <input type="password" className="profile-input" value={passForm.newPassword} onChange={(e) => setPassForm({ ...passForm, newPassword: e.target.value })} required />
            </div>
            <div className="profile-field">
              <label className="profile-label">Confirm New Password</label>
              <input type="password" className="profile-input" value={passForm.confirmPassword} onChange={(e) => setPassForm({ ...passForm, confirmPassword: e.target.value })} required />
            </div>
            <button type="submit" className="profile-save-btn" disabled={changingPass}>
              {changingPass ? 'Changing...' : 'Change Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Profile;
